import React from "react";
import {
  Row,
  Label,
  Input,
  FormGroup,
  Col,
  CardBody,
  Container,
  Card,
  Button,
  Form,
} from "reactstrap";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import { useFormik } from "formik";
import * as yup from "yup";

interface BasicInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const CheckInformation = ({
  onSubmit,
  onBack,
  data,
}: BasicInformationProps) => {
  //meta title
  document.title = "Ditobanx";

  const representativeInfo = data.representativeInfo;
  const documents = data.documents;
  const shareHolders: any = data.holdersInfo || [];
  const businessInfo = data.businessInfo;
  const financialInfo = data.financialInfo;

  // console.log({
  //   representativeInfo,
  //   shareHolders,
  //   businessInfo,
  //   financialInfo,
  // });

  let date_of_birth: any;
  if (businessInfo?.dateOfBirth) {
    date_of_birth = new Date(businessInfo?.dateOfBirth)
      .toISOString()
      .split("T")[0];
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      isAcceptedTerms: false,
      privacyPolicyAccepted: false,
      certificationStatement: false,
    },
    validationSchema: yup.object().shape({
      isAcceptedTerms: yup
        .boolean()
        .oneOf([true], "Debes aceptar los términos"),
      privacyPolicyAccepted: yup
        .boolean()
        .oneOf([true], "Debes aceptar la política de privacidad"),
      certificationStatement: yup
        .boolean()
        .oneOf([true], "Debes aceptar la certificación de datos"),
    }),
    onSubmit: (values) => {
      // console.log("✅ Todos los checkboxes marcados correctamente:", values);
      onSubmit(values);
    },
  });

  return (
    <React.Fragment>
      <Container className="mt-5">
        <Form onSubmit={validation.handleSubmit}>
          <Card
            className="mt-4"
            style={{ backgroundColor: "#fff", borderRadius: "8px" }}
          >
            <CardBody>
              {/* Información Personal */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <h5 className="mb-3">Información Representante Legal</h5>
                  <p className="mb-1">
                    <strong>Nombre:</strong>{" "}
                    {representativeInfo?.fullName || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Email:</strong>{" "}
                    {representativeInfo?.email || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>País:</strong>{" "}
                    {representativeInfo?.country || "No disponible"}
                  </p>
                </Col>
              </Row>

              {/* Información de la Empresa */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <h5 className="mb-3">Información de la Empresa</h5>
                  <p className="mb-1">
                    <strong>Numero de registro:</strong>{" "}
                    {businessInfo?.document_number || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Nacionalidad:</strong>{" "}
                    {businessInfo?.nacionality || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Fecha de Conciliacion:</strong>{" "}
                    {date_of_birth || "No disponible"}
                  </p>
                </Col>
              </Row>

              {/* INFORMACIO FINANCIERA */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <h5 className="mb-3">Informacion Financiera</h5>
                  <p className="mb-1">
                    <strong>Actividad Economica:</strong>{" "}
                    {financialInfo?.economicActivity || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Ingresos:</strong>{" "}
                    {financialInfo?.income || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>origen de los fondos:</strong>{" "}
                    {financialInfo?.sourceOfFunds || "No disponible"}
                  </p>
                </Col>
              </Row>

              {/* Información Financiera */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <h5 className="mb-3">Accionistas y Beneficiarios</h5>
                  {shareHolders.map((item) => (
                    <div
                      style={{
                        marginTop: 10,
                        border: "1px solid black",
                        padding: 10,
                      }}
                    >
                      <p className="mb-1">
                        <strong>Nombre Completo:</strong>{" "}
                        {item?.full_name || "No disponible"}
                      </p>
                      <p className="mb-1">
                        <strong>Numero de documento:</strong>{" "}
                        {item?.document_number || "No disponible"}
                      </p>
                      <p className="mb-1">
                        <strong>Porcentaje:</strong>{" "}
                        {item?.percentage || "No disponible"}
                      </p>
                    </div>
                  ))}
                </Col>
              </Row>

              {/* Checkboxes */}

              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <FormGroup check className="mb-2">
                    <Label check>
                      <Input
                        type="checkbox"
                        name="isAcceptedTerms"
                        checked={validation.values.isAcceptedTerms}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                      />
                      &nbsp; Acepto los{" "}
                      <a
                        href="https://ditobanx.com/terminos-y-condiciones/"
                        target="blank"
                      >
                        términos y condiciones{" "}
                      </a>{" "}
                      del servicio
                    </Label>
                    {validation.touched.isAcceptedTerms &&
                      validation.errors.isAcceptedTerms && (
                        <div className="text-danger">
                          {validation.errors.isAcceptedTerms}
                        </div>
                      )}
                  </FormGroup>

                  <FormGroup check className="mb-2">
                    <Label check>
                      <Input
                        type="checkbox"
                        name="privacyPolicyAccepted"
                        checked={validation.values.privacyPolicyAccepted}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                      />
                      &nbsp; Acepto la{" "}
                      <a
                        href="https://ditobanx.com/polica-de-privacidad/"
                        target="blank"
                      >
                        política de privacidad{" "}
                      </a>{" "}
                      y el procesamiento de mis datos personales
                    </Label>
                    {validation.touched.privacyPolicyAccepted &&
                      validation.errors.privacyPolicyAccepted && (
                        <div className="text-danger">
                          {validation.errors.privacyPolicyAccepted}
                        </div>
                      )}
                  </FormGroup>

                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="certificationStatement"
                        checked={validation.values.certificationStatement}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                      />
                      &nbsp; Certifico que la información proporcionada es
                      verdadera y precisa
                    </Label>
                    {validation.touched.certificationStatement &&
                      validation.errors.certificationStatement && (
                        <div className="text-danger">
                          {validation.errors.certificationStatement}
                        </div>
                      )}
                  </FormGroup>
                </Col>
              </Row>
              {/* Botones */}
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {/* <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={onBack}
                >
                  Regresar
                </button> */}
                <Button
                  type="submit"
                  className="btn btn-primary"
                  // disabled={!validation.isValid || validation.isSubmitting}
                >
                  Siguiente
                </Button>
              </div>
            </CardBody>
          </Card>
        </Form>
      </Container>
    </React.Fragment>
  );
};

export default CheckInformation;
